import React from 'react';
import './loading.css';

/** Inline animated dots for buttons during submit / upload. */
const ButtonLoader = ({ label = '' }) => (
  <span className="button-loader" role="status" aria-live="polite">
    <span className="button-loader__dot" />
    <span className="button-loader__dot" />
    <span className="button-loader__dot" />
    {label ? <span className="button-loader__label">{label}</span> : null}
  </span>
);

export default ButtonLoader;
